export function getPrimaryPod(teams) {
  return Array.isArray(teams) ? teams.find((team) => team.isPrimaryPod()) : null;
}
